module.exports = __webpack_public_path__ + "img/water_droplet_3.a17e6255.svg";